import { Outlet, createFileRoute } from '@tanstack/react-router';

import { requireOrganizationRoute } from '@/lib/router-guards';

export const Route = createFileRoute('/_app/publishing')({
    beforeLoad: requireOrganizationRoute,
    component: PublishingLayout
});

function PublishingLayout() {
    return <Outlet />;
}
